export default "__VITE_ASSET__DnYzFvh8__"